const UltimateMember = (loginButton) => {
    if (loginButton) {

        const svg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="none">
            <path d="M5.33325 12H18.6666" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"/>
            <path d="M18.6665 12C16.1665 9.5 15.3332 8.66667 13.6665 7" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"/>
            <path d="M18.6665 12C16.9998 13.6667 15.7498 14.9167 13.6665 17" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round"/>
        </svg>`;

        const buttonHtml = `<button class="um-button btn btn--secondary" type="submit">Login ${svg}</button>`;

        // Create a temporary container to convert the string into a DOM element
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = buttonHtml;
        const button = tempContainer.firstChild;

        loginButton.remove();

        var umColAltElement = document.querySelector(".um-col-alt");

        if (umColAltElement) {
            umColAltElement.insertAdjacentElement('afterend', button);
        } else {
            var form = document.querySelector(".um-form form");
            form.insertAdjacentHTML('beforeend', button);
        }
    }
}

export default UltimateMember;
